import ToggleSwitch from "legacy/ToggleSwitch"
import PropTypes from "prop-types"
import React from "react"

class ReportToggle extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reportType: this.props.reportType,
    }

    this.toggleChange = this.toggleChange.bind(this)
    this.additionalGetParams = this.additionalGetParams.bind(this)
    this.togglePosition = this.togglePosition.bind(this)
  }

  additionalGetParams() {
    let additionalParams = ""
    if (this.props.startDate) {
      additionalParams +=
        "&start_date=" + encodeURIComponent(this.props.startDate)
    }
    if (this.props.endDate) {
      additionalParams += "&end_date=" + encodeURIComponent(this.props.endDate)
    }

    return additionalParams
  }

  toggleChange(togglePosition) {
    const reportType = {
      left: this.props.valLeft,
      right: this.props.valRight,
    }
    this.setState({ reportType: reportType[togglePosition] })
    window.location.href =
      this.props.redirectUrl +
      "?report_type=" +
      reportType[togglePosition] +
      this.additionalGetParams()
  }

  togglePosition() {
    if (this.state.reportType === this.props.valLeft) {
      return "left"
    } else {
      return "right"
    }
  }

  render() {
    return (
      <div>
        <ToggleSwitch
          labelLeft={this.props.labelLeft}
          labelRight={this.props.labelRight}
          tellParent={this.toggleChange}
          startPosition={this.togglePosition()}
          additionalCssClasses="mega"
        />
        <input type="hidden" name="report_type" value={this.state.reportType} />
      </div>
    )
  }
}

ReportToggle.propTypes = {
  reportType: PropTypes.string.isRequired,
  labelLeft: PropTypes.string.isRequired,
  labelRight: PropTypes.string.isRequired,
  valLeft: PropTypes.string.isRequired,
  valRight: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default ReportToggle
